// The active endpoints of the Analitica tab of the DataPanel, decorated for
// the list (property title, sort key). Copies: the rows are not changed, so
// that what is saved (the draft row) never carries property and sortKey.
export function decorateEndpoints(rows, propertyTitle) {
  return rows
    .filter(({ active }) => active)
    .map((endpoint) => {
      const property = endpoint.propertyId
        ? propertyTitle(endpoint.propertyId)
        : undefined;

      return {
        ...endpoint,
        property,
        sortKey: `${property ?? ""} ${endpoint.title}`.trim()
      };
    });
}
